import { type Component, Show } from "solid-js";
import type { Coordinates, EntitySize } from "~/solidJs/shared/helpers/types/ISizeble";
import { StyledTooltip } from "~/solidJs/shared/ui/atoms/Tooltip";
import { useOverlayTooltip } from "./methods";
import type { TooltipData } from "./model";

interface OverlayTooltipComponentProps {
	isOpen: () => boolean;
	position: () => Coordinates & EntitySize;
	tooltipData: () => TooltipData | null;
	onClose: () => void;
}

const OverlayTooltip: Component<OverlayTooltipComponentProps> = (props) => {
	return (
		<Show when={props.isOpen()}>
			<StyledTooltip.TooltipClosedComponent
				showArrow
				portaled={false}
				rootProps={{
					open: props.isOpen(),
					onOpenChange: (d) => {
						if (!d.open) {
							props.onClose();
						}
					},
					positioning: {
						placement: "top",
						gutter: 10
					}
				}}
				content={
					<div class="caption-12-regular whitespace-pre-line text-white">
						{props.tooltipData()?.text || ""}
					</div>
				}
			>
				{(p) => (
					<button
						{...p}
						style={{
							left: `${props.position().left}px`,
							top: `${props.position().top}px`,
							width: `${props.position().width}px`,
							height: `${props.position().height}px`
						}}
						class="pointer-events-none absolute z-[1000]"
					/>
				)}
			</StyledTooltip.TooltipClosedComponent>
		</Show>
	);
};

export const OverlayTooltipPalette: Component = () => {
	const { isOpen, position, tooltipData } = useOverlayTooltip();

	return (
		<OverlayTooltip
			isOpen={isOpen}
			position={position}
			tooltipData={tooltipData}
			onClose={() => useOverlayTooltip().setIsOpen(false)}
		/>
	);
};
